/* eslint-disable  */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import { useContext } from 'react';
import images from '../Resources/Images';
import AppContext from '../Store/AppContext';
import { logout } from '../Utils/index';

export default function PrivacyPolicyDialog({ open, onClose, onAccept }) {
  const { clientDetails } = useContext(AppContext);
  const isLoggedIn = Boolean(clientDetails && clientDetails.firstName);

  const handleAccept = () => {
    // TODO: add any “accepted” side-effect here (e.g. API call or localStorage flag)
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {

        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }

        onClose();
      }}
      fullWidth
      maxWidth="md"
      scroll="paper"
      disableScrollLock={true}

    >
      <DialogTitle sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2, pt: 1, pb: 0, minHeight: 54 }}>
        <img src={images.LogoPng} alt="logo" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', width: 125, height: 54, padding: 10 }} />
        <Box sx={{ fontWeight: 700, fontSize: '1.25rem', lineHeight: 1.3, textAlign: 'center' }}>
          Terms of use and confidentiality agreement
        </Box>
      </DialogTitle>
      <Typography variant="subtitle2" sx={{ textAlign: 'center', mt: 0.5, mb: 0.5 }}>
        Version 1.0 · Please read and accept to continue. You will only be asked again if these terms change.
      </Typography>
      <DialogContent dividers>
        {/* <Typography paragraph>
          This Privacy Policy describes how Reg-X Innovations Limited (“Reg-X,” “we,” “us,” or “our”) collects, uses, shares, and protects personal data through your interaction with our services, including:
        </Typography>
        <ul>
          <li>Visiting our website: <a href="https://www.reg-x.co.uk" target="_blank" rel="noopener noreferrer">www.reg-x.co.uk</a></li>
          <li>Engaging with us via sales, support, marketing, events, or other channels linked to this Privacy Policy</li>
        </ul>
        <Typography paragraph>
          We tailor solutions to different client needs to establish a valuable partnership with our clients for better compliance.  
          If you have questions or concerns, please contact us at <a href="mailto:info@reg-x.co.uk">info@reg-x.co.uk</a>.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>SUMMARY OF KEY POINTS</Typography> */}
        <Box component="dl" sx={{ pl: 2 }}>
          <Typography component="dt"><strong>Authorised use only</strong></Typography>
          <Typography component="dd">This system is for authorised users only. Unauthorised access or use is prohibited and may result in legal action, including criminal prosecution. If you are not an authorised user, disconnect now and report accidental access to support@reg-x.co.uk.</Typography>
          <Divider sx={{ my: 2 }} />
          <Typography component="dt"><strong>Intellectual property</strong></Typography>
          <Typography component="dd">The software, design, workflows, data models, documentation and content on this platform are proprietary to Reg-X Innovations Ltd and protected by copyright. Except as your licence agreement allows, you must not copy, reproduce, reverse engineer, publish or distribute any part of it, or use it to build a competing or substitute product. This includes screenshots, recordings and written descriptions of its functionality.</Typography>
          <Divider sx={{ my: 2 }} />
          <Typography component="dt"><strong>Confidentiality</strong></Typography>
          <Typography component="dd">You agree to keep all platform content confidential and to comply with all relevant data protection and regulatory requirements.</Typography>
          <Divider sx={{ my: 2 }} />
          <Typography component="dt"><strong>Monitoring</strong></Typography>
          <Typography component="dd">Activity on this platform is monitored and logged for security, compliance and audit purposes. Your acceptance of these terms is recorded with your user ID, the date and time, and the version accepted.</Typography>

          {/* <Typography component="dt"><strong>Data security?</strong></Typography>
          <Typography component="dd">We implement strong technical and organisational measures, but no method is 100% secure.</Typography>

          <Typography component="dt"><strong>Your rights?</strong></Typography>
          <Typography component="dd">Under GDPR and UK law, you may access, correct, or delete your data and manage how we use it.</Typography> */}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* <Typography variant="h6" gutterBottom>TABLE OF CONTENTS</Typography>
        <ol>
          <li>Information We Collect</li>
          <li>How We Use Your Information</li>
          <li>Legal Bases for Processing</li>
          <li>Sharing Your Data</li>
          <li>Retention Periods</li>
          <li>Data Security</li>
          <li>Data from Minors</li>
          <li>Your Rights</li>
          <li>Do-Not-Track Signals</li>
          <li>Policy Updates</li>
          <li>Contacting Us</li>
          <li>Managing Your Data</li>
        </ol> */}

        {/* Section 1 */}
        {/* <Typography variant="subtitle1" gutterBottom>1. INFORMATION WE COLLECT</Typography>
        <Typography paragraph>
          We collect personal data you voluntarily submit, such as:
        </Typography>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Job title</li>
        </ul>
        <Typography paragraph>
          You are responsible for ensuring that the personal data provided is accurate and current. We do not collect or process sensitive personal data (e.g., health or financial information).
        </Typography> */}

        {/* Section 2 */}
        {/* <Typography variant="subtitle1" gutterBottom>2. HOW WE USE YOUR INFORMATION</Typography>
        <Typography paragraph>
          We process personal data to:
        </Typography>
        <ul>
          <li>Create and manage user accounts</li>
          <li>Deliver services or respond to inquiries</li>
          <li>Communicate product updates or administrative changes</li>
          <li>Meet legal and contractual obligations</li>
          <li>Prevent fraud or ensure data security</li>
        </ul> */}

        {/* Section 3 */}
        {/* <Typography variant="subtitle1" gutterBottom>3. LEGAL BASES FOR PROCESSING</Typography>
        <Typography paragraph>
          We rely on the following legal bases under the UK GDPR:
        </Typography>
        <ul>
          <li>Consent (when explicitly given)</li>
          <li>Contractual necessity (to deliver services)</li>
          <li>Legal obligation (e.g., HMRC or FCA compliance)</li>
          <li>Legitimate interests (e.g., business growth, user support)</li>
          <li>Vital interests (to protect users or prevent harm)</li>
        </ul> */}

        {/* Section 4 */}
        {/* <Typography variant="subtitle1" gutterBottom>4. SHARING YOUR DATA</Typography>
        <Typography paragraph>
          We only share data in the following contexts:
        </Typography>
        <ul>
          <li><strong>Business transfers</strong>: As part of a merger, acquisition, or asset sale</li>
          <li><strong>Legal requests</strong>: If required by law enforcement or regulators</li>
        </ul>
        <Typography paragraph>We do not sell or rent personal data to third parties.</Typography> */}

        {/* Section 5 */}
        {/* <Typography variant="subtitle1" gutterBottom>5. RETENTION PERIODS</Typography>
        <Typography paragraph>
          We retain personal data only as long as necessary to fulfil the purpose for which it was collected, or to comply with legal and contractual obligations.
        </Typography>
        <Typography paragraph>
          When retention is no longer necessary, we securely delete or anonymise your data.
        </Typography> */}

        {/* Section 6 */}
        {/* <Typography variant="subtitle1" gutterBottom>6. DATA SECURITY</Typography>
        <Typography paragraph>
          We implement appropriate organisational and technical safeguards, including:
        </Typography>
        <ul>
          <li>Data encryption (in transit and at rest)</li>
          <li>Access controls</li>
          <li>Monitoring and audits</li>
        </ul>
        <Typography paragraph>
          However, no system is completely secure. You use our services at your own risk.
        </Typography> */}

        {/* Section 7 */}
        {/* <Typography variant="subtitle1" gutterBottom>7. DATA FROM MINORS</Typography>
        <Typography paragraph>
          Our services are not directed at individuals under the age of 18. If we become aware of collecting personal data from a minor, we will delete it immediately.
        </Typography> */}

        {/* Section 8 */}
        {/* <Typography variant="subtitle1" gutterBottom>8. YOUR RIGHTS</Typography>
        <Typography paragraph>
          Under applicable data protection laws (UK, EEA, Switzerland), you have the right to:
        </Typography>
        <ul>
          <li>Access and obtain a copy of your data</li>
          <li>Correct inaccurate or outdated information</li>
          <li>Request deletion or restriction of processing</li>
          <li>Withdraw consent at any time</li>
          <li>Object to direct marketing or profiling</li>
          <li>File a complaint with a data protection authority</li>
        </ul>
        <Typography paragraph>
          Contact us at <a href="mailto:info@reg-x.co.uk">info@reg-x.co.uk</a> to exercise these rights.
        </Typography> */}

        {/* Section 9 */}
        {/* <Typography variant="subtitle1" gutterBottom>9. DO-NOT-TRACK FEATURES</Typography>
        <Typography paragraph>
          We currently do not respond to browser-based “Do-Not-Track” signals due to a lack of standardization.
        </Typography> */}

        {/* Section 10 */}
        {/* <Typography variant="subtitle1" gutterBottom>10. POLICY UPDATES</Typography>
        <Typography paragraph>
          We may update this Privacy Policy to remain compliant with changing laws or business practices. Changes will be effective immediately upon posting, with the updated “Last Reviewed” date.
        </Typography> */}

        {/* Section 11 */}
        {/* <Typography variant="subtitle1" gutterBottom>11. CONTACTING US</Typography>
        <Typography paragraph>
          <strong>Data Protection Officer:</strong> Swadhin Kumar<br />
          <strong>Email:</strong> <a href="mailto:swadhin.kumar@reg-x.co.uk">swadhin.kumar@reg-x.co.uk</a><br />
          <strong>Phone:</strong> +44 7950 232430<br />
          <strong>Address:</strong><br />
          Reg-X Innovations Ltd<br />
          63/66 Hatton Garden, Fifth Floor, Suite 23<br />
          London EC1N 8LE<br />
          United Kingdom
        </Typography> */}

        {/* Section 12 */}
        {/* <Typography variant="subtitle1" gutterBottom>12. MANAGING YOUR DATA</Typography>
        <Typography paragraph>
          To view, update, or delete your personal information, email <a href="mailto:info@reg-x.co.uk">info@reg-x.co.uk</a> with your request. We will respond in accordance with applicable law.
        </Typography> */}

        <Typography variant="caption" align="center" display="block">
          Reg-X Innovations Ltd is committed to protecting your privacy and handling your personal data with transparency and accountability.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={logout}>Decline and sign out</Button>
        {isLoggedIn && (
          <Button onClick={onAccept} variant="contained" color="primary">
            Accept and continue
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
